import { Tile } from 'common/tile/tile.js';
import { ImageTile } from 'components/tiles/image-tile.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { useContext } from 'react';
import { IModule } from 'redux-state/layout/types.js';
import { ILink } from 'types/navigation.js';

interface IMapSideBar {
  title: string;
  image: string;
  link?: ILink;
}

export const MapSideBar = (props: IModule<IMapSideBar>) => {
  const isLarge = useContext(ColumnLayoutContext) !== '1-column';
  const { config } = props;

  return (
    <Tile dataModule="map-sidebar" {...props}>
      <div className="Tile-body Tile-body--noPadding">
        {isLarge ? <ImageTile {...config} /> : <ImageTile {...config} ratio="special-wide" />}
      </div>
    </Tile>
  );
};
